import { render, staticRenderFns } from "./policiesAndRegulationsDetail.vue?vue&type=template&id=dbdac3b6&scoped=true&"
import script from "./policiesAndRegulationsDetail.vue?vue&type=script&lang=js&"
export * from "./policiesAndRegulationsDetail.vue?vue&type=script&lang=js&"
import style0 from "./policiesAndRegulationsDetail.vue?vue&type=style&index=0&id=dbdac3b6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbdac3b6",
  null
  
)

export default component.exports